import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import { StackingAlertBanner } from '@saviynt/design-system';

import { setCertsListActionStatus } from '../../../redux/certlist/action';
import { useInvertedLocalize } from '../../../utils/localization';
import { getMessageKey } from '../../../utils/utils';
import { ACT_DISCONTINUE, ACT_REASSIGN } from '../constant';

import { invertedMessages } from './messages';

function CertsListActionAlerts() {
  const dispatch = useDispatch();
  const [alertStatus, setAlertStatus] = useState(null);
  const l = useInvertedLocalize(invertedMessages);

  const { lineAction: { certsActionStatus } = {} } = useSelector(
    (state) => state?.certifications?.list
  );
  const intl = useIntl();
  const { messages } = useSelector((state) => state?.user) || {};

  useEffect(() => {
    const currentStatus = certsActionStatus?.status;
    const currentAction = certsActionStatus?.action;

    switch (currentStatus) {
      case 'SUCCESS':
      case 'INFO':
        setAlertStatus(currentStatus);
        break;
      case 'FAILED':
        // In case action is discontinue or reassign, if api is failed,
        // alert show inside the modal instead of alert banner
        // hence not setting currentStatus, which will not trigger alert banner
        if (
          !(currentAction === ACT_DISCONTINUE || currentAction === ACT_REASSIGN)
        ) {
          setAlertStatus(currentStatus);
        } else {
          setAlertStatus('');
        }

        break;
      default:
        setAlertStatus('');
        break;
    }
  }, [certsActionStatus]);

  const alertConfigs = {
    SUCCESS: {
      colorTheme: 'Information',
      title:
        messages.CERTS_ACTION_ALERTS_SUCCESS ||
        localize(intl, getMessageKey('CERTS_ACTION_ALERTS_SUCCESS')),
      description: certsActionStatus?.response,
    },
    FAILED: {
      colorTheme: 'Critical',
      title:
        messages.CERTS_ACTION_ALERTS_TITLE ||
        localize(intl, getMessageKey('CERTS_ACTION_ALERTS_TITLE')),
      description: certsActionStatus?.response
        ? certsActionStatus.response
        : messages.CERTS_ACTION_ALERTS_DESCRIPTION ||
          localize(intl, getMessageKey('CERTS_ACTION_ALERTS_DESCRIPTION')),
    },
    INFO: {
      colorTheme: 'Information',
      title:
        messages.EXPORT_ALERT_FAILED412_TITLE ||
        localize(intl, getMessageKey('EXPORT_ALERT_FAILED412_TITLE')),
      description: certsActionStatus?.response,
    },
  };

  const config = alertConfigs[alertStatus];

  return config ? (
    <StackingAlertBanner
      colorTheme={config.colorTheme}
      title={config.title}
      description={l(config.description)}
      isVisible={config}
      kind='low'
      onCancel={() => {
        setAlertStatus('');
        dispatch(setCertsListActionStatus(null));
      }}
      shouldAutoDismiss
    />
  ) : null;
}

export default CertsListActionAlerts;
